// color-swatch-switcher.js
// Updated with support for variant-picker, product-form, and enabling default variant after swatch switch
// Now includes quick view modal support with conflict prevention

const colorSwatchCache = new Map();

// Preload swatch product on hover
document.addEventListener('mouseenter', function (e) {
  if (!e.target || !(e.target instanceof Element)) return;
  const li = e.target.closest('[data-color-swatches-from-metafields] li');
  if (!li) return;

  const radio = li.querySelector('.ColorSwatch__Radio');
  if (radio?.dataset.variantUrl && !colorSwatchCache.has(radio.dataset.variantUrl)) {
    fetch(radio.dataset.variantUrl)
      .then(res => res.text())
      .then(html => colorSwatchCache.set(radio.dataset.variantUrl, html))
      .catch(() => {});
  }
}, true);

// Handle swatch click and replace product - PDP specific
document.addEventListener('click', function (e) {
  if (!e.target || !(e.target instanceof Element)) return;
  
  // Only handle clicks within main product section (PDP context)
  const mainProductSection = e.target.closest('.shopify-section--main-product');
  if (!mainProductSection) return;
  
  const li = e.target.closest('[data-color-swatches-from-metafields] li');
  if (!li) return;

  const radio = li.querySelector('.ColorSwatch__Radio');
  if (!radio?.dataset.variantUrl) return;

  e.preventDefault();
  const variantUrl = radio.dataset.variantUrl;
  const productHandle = radio.dataset.productHandle;

  li.classList.add('loading');

  const handleResponse = (htmlString) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, 'text/html');
    const newRerender = doc.querySelector('product-rerender');
    const oldRerender = mainProductSection.querySelector('product-rerender');

    if (!newRerender || !oldRerender) return;

    oldRerender.replaceWith(newRerender);

    requestAnimationFrame(() => {
      upgradeCustomElements(newRerender);

      const productForm = newRerender.querySelector('product-form');
      if (productForm) {
        try {
          productForm.__proto__.connectedCallback.call(productForm);
        } catch (e) {
          console.warn('[Swatch] Failed to re-run connectedCallback on product-form:', e);
        }
      }

      const picker = newRerender.querySelector('variant-picker');
      const form = newRerender.querySelector('product-form form');

      if (picker && form) {
        try {
          picker.__proto__.connectedCallback.call(picker);
        } catch (e) {
          console.warn('[Swatch] Failed to re-run connectedCallback on variant-picker:', e);
        }

        picker.closest = (selector) => {
          if (selector === 'form') return form;
          return HTMLElement.prototype.closest.call(picker, selector);
        };

        // Automatically select default variant to enable hidden input[name="id"]
        const script = picker.querySelector('script[data-variant]');
        if (script) {
          const variant = JSON.parse(script.textContent);
          if (variant?.options?.length) {
            picker.selectCombination({ optionValues: variant.options, productChange: false });
          }
        }

      }

      // Optional: Dispatch Shopify hydration
      document.dispatchEvent(new Event('DOMContentLoaded', { bubbles: true }));

      // Update swatch UI state within the main product section
      updateSelectedColorSwatchInSection(mainProductSection, productHandle);

      // Update URL (optional)
      window.history.replaceState({}, '', variantUrl);

      li.classList.remove('loading');
    });
  };

  if (colorSwatchCache.has(variantUrl)) {
    handleResponse(colorSwatchCache.get(variantUrl));
  } else {
    fetch(variantUrl)
      .then(res => res.text())
      .then(data => {
        colorSwatchCache.set(variantUrl, data);
        handleResponse(data);
      })
      .catch(err => {
        console.error('Swatch error:', err);
        li.classList.remove('loading');
      });
  }
});

// Quick View Modal Swatch Handler
document.addEventListener('click', function (e) {
  if (!e.target || !(e.target instanceof Element)) return;
  
  // Check if click is within a quick-buy-modal
  const quickBuyModal = e.target.closest('quick-buy-modal');
  if (!quickBuyModal) return;
  
  const li = e.target.closest('[data-color-swatches-from-metafields] li');
  if (!li) return;

  const radio = li.querySelector('.ColorSwatch__Radio');
  if (!radio?.dataset.variantUrl) return;

  e.preventDefault();
  const variantUrl = radio.dataset.variantUrl;
  const productHandle = radio.dataset.productHandle;

  li.classList.add('loading');

  const handleQuickViewResponse = (htmlString) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, 'text/html');
    
    // Find the quick-buy-content template in the fetched HTML
    const newQuickBuyContent = doc.getElementById('quick-buy-content');
    if (!newQuickBuyContent) return;

    // Get the current product-rerender in the modal
    const currentRerender = quickBuyModal.querySelector('product-rerender');
    if (!currentRerender) return;

    // Get the new product-rerender from the template
    const newRerender = newQuickBuyContent.content.querySelector('product-rerender');
    if (!newRerender) return;

    // Replace the current rerender with the new one
    currentRerender.replaceWith(newRerender.cloneNode(true));

    requestAnimationFrame(() => {
      const newRerenderInModal = quickBuyModal.querySelector('product-rerender');
      if (!newRerenderInModal) return;

      upgradeCustomElements(newRerenderInModal);

      const productForm = newRerenderInModal.querySelector('product-form');
      if (productForm) {
        try {
          productForm.__proto__.connectedCallback.call(productForm);
        } catch (e) {
          console.warn('[QuickView Swatch] Failed to re-run connectedCallback on product-form:', e);
        }
      }

      const picker = newRerenderInModal.querySelector('variant-picker');
      const form = newRerenderInModal.querySelector('product-form form');

      if (picker && form) {
        try {
          picker.__proto__.connectedCallback.call(picker);
        } catch (e) {
          console.warn('[QuickView Swatch] Failed to re-run connectedCallback on variant-picker:', e);
        }

        picker.closest = (selector) => {
          if (selector === 'form') return form;
          return HTMLElement.prototype.closest.call(picker, selector);
        };

        // Automatically select default variant to enable hidden input[name="id"]
        const script = picker.querySelector('script[data-variant]');
        if (script) {
          const variant = JSON.parse(script.textContent);
          if (variant?.options?.length) {
            picker.selectCombination({ optionValues: variant.options, productChange: false });
          }
        }
      }

      // Update swatch UI state within the modal
      updateSelectedColorSwatchInModal(quickBuyModal, productHandle);

      li.classList.remove('loading');
    });
  };

  if (colorSwatchCache.has(variantUrl)) {
    handleQuickViewResponse(colorSwatchCache.get(variantUrl));
  } else {
    fetch(variantUrl)
      .then(res => res.text())
      .then(data => {
        colorSwatchCache.set(variantUrl, data);
        handleQuickViewResponse(data);
      })
      .catch(err => {
        console.error('QuickView Swatch error:', err);
        li.classList.remove('loading');
      });
  }
});

// Product Card Swatch Handler (separate from PDP)
document.addEventListener('click', function (e) {
  if (!e.target || !(e.target instanceof Element)) return;
  
  // Only handle product card swatches (not within main product section or quick-buy-modal)
  const mainProductSection = e.target.closest('.shopify-section--main-product');
  const quickBuyModal = e.target.closest('quick-buy-modal');
  
  if (mainProductSection || quickBuyModal) return; // Skip if in PDP or quick view
  
  const li = e.target.closest('[data-color-swatches-from-metafields] li');
  if (!li) return;

  const radio = li.querySelector('.ColorSwatch__Radio');
  if (!radio?.dataset.variantUrl) return;

  e.preventDefault();
  const variantUrl = radio.dataset.variantUrl;
  const productHandle = radio.dataset.productHandle;

  li.classList.add('loading');

  // For product cards, we'll navigate to the new product page
  window.location.href = variantUrl;
});

function upgradeCustomElements(container) {
  const tags = ['variant-picker', 'buy-buttons', 'product-gallery', 'product-form', 'shopify-payment-button'];
  tags.forEach(tag => {
    const el = container.querySelector(tag);
    if (el && typeof customElements.get(tag) === 'function') {
      customElements.upgrade(el);
    }
  });
}

function updateSelectedColorSwatchInSection(section, productHandle) {
  const allRadios = section.querySelectorAll('[data-color-swatches-from-metafields] .ColorSwatch__Radio');
  allRadios.forEach(r => (r.checked = false));

  const selected = section.querySelector(`[data-color-swatches-from-metafields] .ColorSwatch__Radio[data-product-handle="${productHandle}"]`);
  if (selected) selected.checked = true;

  const allLis = section.querySelectorAll('[data-color-swatches-from-metafields] li');
  allLis.forEach(li => li.classList.remove('selected'));
  if (selected) selected.closest('li')?.classList.add('selected');
}

function updateSelectedColorSwatchInModal(modal, productHandle) {
  const allRadios = modal.querySelectorAll('[data-color-swatches-from-metafields] .ColorSwatch__Radio');
  allRadios.forEach(r => (r.checked = false));

  const selected = modal.querySelector(`[data-color-swatches-from-metafields] .ColorSwatch__Radio[data-product-handle="${productHandle}"]`);
  if (selected) selected.checked = true;

  const allLis = modal.querySelectorAll('[data-color-swatches-from-metafields] li');
  allLis.forEach(li => li.classList.remove('selected'));
  if (selected) selected.closest('li')?.classList.add('selected');
}